import {
  NoiseEventsHistoryQueryVariables,
  GetNoiseEventsHistoryBaseQuery,
  GetNoiseEventsHistoryBaseQueryVariables,
  GetNoiseEventsHistoryResourceGroupsQuery,
  GetNoiseEventsHistoryResourceGroupsQueryVariables,
  GetNoiseEventsHistoryClassificationQuery,
  GetNoiseEventsHistoryClassificationQueryVariables,
} from 'app/__generated__/global';
import { ApolloProvider } from 'core/net/ApolloProvider';
import { GET_NOISE_EVENTS_HISTORY_BASE } from './graphql/facility.getNoiseEventsHistoryBase';
import { GET_NOISE_EVENTS_HISTORY_RESOURCE_GROUPS } from './graphql/facility.getNoiseEventsHistoryResourceGroups';
import { GET_NOISE_EVENTS_HISTORY_CLASSIFICATION } from './graphql/facility.getNoiseEventsHistoryClassification';

export const getNoiseEventsHistoryBase = async (variables: NoiseEventsHistoryQueryVariables) => {
  const { data, error } = await ApolloProvider.global().query<
    GetNoiseEventsHistoryBaseQuery,
    GetNoiseEventsHistoryBaseQueryVariables
  >({
    query: GET_NOISE_EVENTS_HISTORY_BASE,
    variables,
  });
  if (!data || error)
    throw new Error(
      `Something went wrong when trying to get noise events history base data\n${JSON.stringify(error, null, 2)}`
    );
  return data.facility?.noiseEvents;
};

export const getNoiseEventsHistoryResourceGroups = async (variables: GetNoiseEventsHistoryBaseQueryVariables) => {
  const { data, error } = await ApolloProvider.global().query<
    GetNoiseEventsHistoryResourceGroupsQuery,
    GetNoiseEventsHistoryResourceGroupsQueryVariables
  >({
    query: GET_NOISE_EVENTS_HISTORY_RESOURCE_GROUPS,
    variables,
  });
  if (!data || error)
    throw new Error(
      `Something went wrong when trying to get noise events history resource groups data\n${JSON.stringify(error, null, 2)}`
    );
  return data.facility?.noiseEvents;
};

export const getNoiseEventsHistoryClassification = async (
  variables: GetNoiseEventsHistoryClassificationQueryVariables
) => {
  const { data, error } = await ApolloProvider.global().query<
    GetNoiseEventsHistoryClassificationQuery,
    GetNoiseEventsHistoryClassificationQueryVariables
  >({
    query: GET_NOISE_EVENTS_HISTORY_CLASSIFICATION,
    variables,
  });
  if (!data || error)
    throw new Error(
      `Something went wrong when trying to get noise events history classification data\n${JSON.stringify(error, null, 2)}`
    );
  return data.facility?.noiseEvents;
};
